import React from "react";
import styles from "./ServiceBenifits.module.css";
import { BsClockHistory } from "react-icons/bs";
import { FaCarCrash } from "react-icons/fa";
import { AiOutlineDashboard } from "react-icons/ai";
import { TbReplace } from "react-icons/tb";
import { FiUsers } from "react-icons/fi";

const ServiceBenifits = () => {
  return (
    <div className={styles.sectionContainer}>
      {/* What you get in the car Service Report */}
      <div className={styles.reportSection}>
        <h2 className={styles.sectionTitle}>
          What would yo get in the Vaahan Service Report
        </h2>
        <p className={styles.sectionDescription}>
          A comprehensive Vaahan Service report includes:
        </p>

        <div className={styles.reportCardsContainer}>
          <div className={styles.reportCard}>
            <div className={styles.reportCardContent}>
              <h3 className={styles.cardTitle}>Vaahan Service records</h3>
              <p className={styles.cardDescription}>
                This will provide information about the maintenance and repair work done on
                the vaahan.
              </p>
            </div>
            <div className={styles.iconContainer}>
              <BsClockHistory className={styles.icon} />
            </div>
          </div>

          <div className={styles.reportCard}>
            <div className={styles.reportCardContent}>
              <h3 className={styles.cardTitle}>Accident History</h3>
              <p className={styles.cardDescription}>
                The dates and details of any damages or incidents reported
              </p>
            </div>
            <div className={styles.iconContainer}>
              <FaCarCrash className={styles.icon} />
            </div>
          </div>

          <div className={styles.reportCard}>
            <div className={styles.reportCardContent}>
              <h3 className={styles.cardTitle}>Replaced Parts</h3>
              <p className={styles.cardDescription}>
                A detailed list of parts replaced throughout the life of the vaahan
              </p>
            </div>
            <div className={styles.iconContainer}>
              <TbReplace className={styles.icon} />
            </div>
          </div>

          <div className={styles.reportCard}>
            <div className={styles.reportCardContent}>
              <h3 className={styles.cardTitle}>Odometer readings</h3>
              <p className={styles.cardDescription}>
                Verified mileage readings with an indication if tampering is suspected.
              </p>
            </div>
            <div className={styles.iconContainer}>
              <AiOutlineDashboard className={styles.icon} />
            </div>
          </div>

          <div className={styles.reportCard}>
            <div className={styles.reportCardContent}>
              <h3 className={styles.cardTitle}>Vaahan Owner Details by Chassis No</h3>
              <p className={styles.cardDescription}>
                Insights into the vaahan's ownership timeline and owner details.
              </p>
            </div>
            <div className={styles.iconContainer}>
              <FiUsers className={styles.icon} />
            </div>
          </div>
        </div>
      </div>

      {/* Benefits of Getting Car service History */}
      <div className={styles.benefitsSection}>
        <h2 className={styles.sectionTitle}>
          Benefits of Getting Vaahan service History
        </h2>

        <div className={styles.benefitsCardsContainer}>
          <div className={styles.benefitCard}>
            <div className={styles.benefitCardContent}>
              <h3 className={styles.cardTitle}>Ease of Access</h3>
              <p className={styles.cardDescription}>
                Nothing will take more than a few minutes before you can access a
                vaahan service history online.
              </p>
            </div>
            <div className={styles.iconContainer}>
              <BsClockHistory className={styles.icon} />
            </div>
          </div>

          <div className={styles.benefitCard}>
            <div className={styles.benefitCardContent}>
              <h3 className={styles.cardTitle}>Trustworthy Information</h3>
              <p className={styles.cardDescription}>
                A verified service record and service history for a vaahan ensure reliability.
              </p>
            </div>
            <div className={styles.iconContainer}>
              <FaCarCrash className={styles.icon} />
            </div>
          </div>

          <div className={styles.benefitCard}>
            <div className={styles.benefitCardContent}>
              <h3 className={styles.cardTitle}>Better resell Value</h3>
              <p className={styles.cardDescription}>
                A complete car servicing history increases the market value of the vaahan.
              </p>
            </div>
            <div className={styles.iconContainer}>
              <AiOutlineDashboard className={styles.icon} />
            </div>
          </div>

          <div className={styles.benefitCard}>
            <div className={styles.benefitCardContent}>
              <h3 className={styles.cardTitle}>Buying Decisions</h3>
              <p className={styles.cardDescription}>
                A service history check helps buyers confidently assess a vaahan's condition for
                informed decisions.
              </p>
            </div>
            <div className={styles.iconContainer}>
              <TbReplace className={styles.icon} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceBenifits;